import { FC, useEffect, useRef } from 'react'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import { IDropDown } from './DropDown.type'
import { isEmpty, validateFields } from 'src/utils'
import "./style.css"

const DropDownField: FC<IDropDown> = ({ value, setValue, options, label, isMulti, disabled, placeholder = "All", className, isClearable = true, isRequired, defaultValue }) => {

    const { t } = useTranslation()
    const hasUserInteracted = useRef(false)

    const handleChange = (selectedOption: any) => {
        hasUserInteracted.current = true
        const newValue = selectedOption ? isMulti
            ? selectedOption.map((opt: any) => (
                { label: opt.label, value: opt.value }))
            : { label: selectedOption.label, value: selectedOption.value } : "";

        setValue({ value: newValue, errorMsg: "", isRequired: isRequired });

        validateFields({ setter: setValue, name: label, value: newValue, isRequired });
    };

    useEffect(() => {
        if (defaultValue && !hasUserInteracted.current && isEmpty(value.value)) setValue({ value: defaultValue, errorMsg: "", isRequired });
        setValue({ value: "", errorMsg: "", isRequired })
    }, [defaultValue]);

    return (
        <div className={`form-group ${className}`}>
            <label>{t(label)}</label>
            <Select
                isMulti={isMulti}
                isDisabled={disabled}
                className="MultiSelect"
                classNamePrefix="MultiSelect"
                placeholder={`${t("Select")} ${t(`${placeholder}`)}`}
                options={options?.map((o) => ({ ...o, label: t(o.label) }))}
                value={value?.value}
                id={label}
                onChange={handleChange}
                isClearable={isClearable}
                isSearchable
            />
            {value?.errorMsg && (<div className="invalid-feedback" style={{ display: 'block' }}>{t(value.errorMsg)}</div>)}
        </div>
    )
}

export default DropDownField